import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main className="_main_guvbo_9">
      <section
        className="ds-container p-m tablet:p-m flex flex-col justify-start tablet:justify-start"
        data-section-type="section:text"
      >
        <div className="flex justify-start tablet:justify-start">
          <div className="flex flex-col items-start text-left">
            <div className="relative flex flex-col gap-2">
              <p className="type-title-l tablet:type-title-l">DELIVERY</p>
              <p className="type-title-m tablet:type-title-m">Carrier</p>
              <p className="type-body-s tablet:type-body-s">
                Receive your package directly at your doorstep, or choose
                delivery to a pickup point. If you need fast delivery, we also
                offer express delivery to your home with DHL Express.
              </p>

              <p className="type-title-m tablet:type-title-m">Delivery time</p>
              <p className="type-body-s tablet:type-body-s">
                While we strive to deliver within this timeframe, please keep in
                mind that unforeseen circumstances may sometimes cause delays.
                <br />
                <br />
                The current delivery time is shown when you select the delivery
                method at checkout. The delivery time is also shown on the order
                confirmation.
                <br />
                <br />
                Please note that none of our carriers offer deliveries on
                Saturdays, Sundays or public holidays.
              </p>

              <p className="type-title-m tablet:type-title-m">
                Dynamic Delivery Time
              </p>
              <p className="type-body-s tablet:type-body-s">
                Unless you have been informed otherwise, the usual delivery time
                from the time of placing the order is:
                <br />
                Standard delivery time 3-4 business days (Mon-Fri, excluding
                public holidays)
                <br />
                Express delivery time 1 business day if you order before 17:00
                1-2 business days if you order after 17:00. (Mon-Fri, excluding
                public holidays)
              </p>

              <p className="type-title-m tablet:type-title-m">Shipping cost</p>
              <p className="type-body-s tablet:type-body-s">
                The cost is fixed, regardless of the size or weight of your
                order.
                <br />
                <br />
                The cost you see is the final price, with no additional charges
                or taxes upon delivery.
                <br />
                <br />
                You can view the delivery cost on the product page or in your
                basket before completing your purchase.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Delivery;
